module.exports = "<!-- Footer -->\n<mat-toolbar class=\"footer-content\">\n  <mat-toolbar-row fxLayoutAlign=\"center center\">\n    <div fxLayout=\"column\">\n    <div class=\"footer-text\"> <a (click)='openDialog()' class=\"termsAndCondition\"> Terms and conditions </a> </div>\n    </div>\n  </mat-toolbar-row>\n</mat-toolbar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main